import { ReactNode } from "react"

export type ChipVariant =
    | 'primary'
    | 'secondary'
    | 'success'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'dark'

interface ChipProps {
    children: ReactNode
    variant?: ChipVariant
}

const Chip = ({ children, variant = 'light' }: ChipProps) => (
    <span className={`badge badge-soft-${variant} rounded-pill`}>{children}</span>
)

export default Chip
